/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FormateurHoraireGridDto } from './FormateurHoraireGridDto';
import {
    FormateurHoraireGridDtoFromJSON,
    FormateurHoraireGridDtoFromJSONTyped,
    FormateurHoraireGridDtoToJSON,
} from './FormateurHoraireGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FormateurHoraireGridDtoPaginatedResults
 */
export interface FormateurHoraireGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FormateurHoraireGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FormateurHoraireGridDto>}
     * @memberof FormateurHoraireGridDtoPaginatedResults
     */
    results?: Array<FormateurHoraireGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FormateurHoraireGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FormateurHoraireGridDtoPaginatedResults interface.
 */
export function instanceOfFormateurHoraireGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FormateurHoraireGridDtoPaginatedResultsFromJSON(json: any): FormateurHoraireGridDtoPaginatedResults {
    return FormateurHoraireGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FormateurHoraireGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormateurHoraireGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FormateurHoraireGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FormateurHoraireGridDtoPaginatedResultsToJSON(value?: FormateurHoraireGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FormateurHoraireGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

